function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { motion } from 'framer-motion';
import useStyles from 'isomorphic-style-loader/useStyles';
import cn from 'classnames';
import get from 'lodash/get';
import Avatar from 'components/Avatar';
import Button from 'components/Form/Button';
import ChevronRight from 'svg/chevron-right.svg';
import App from 'modules/App';
import messages from '../../messages';
import styles from './ExternalDataSource.pcss';
import Capabilities from './Capabilities';
import ConnectionStatus from './ConnectionStatus';
const ExternalDataSource = ({ externalDataSource })=>{
    const localizationResources = useSelector(App.selectors.localizationResources);
    const [isExpanded, setIsExpanded] = useState(false);
    useStyles(styles);
    const { dataSourceProvider, nameKey, logo, capabilities } = externalDataSource;
    const name = get(localizationResources, [
        nameKey,
        'value'
    ], dataSourceProvider);
    const dataSourceInfo = messages.dataSourcesInfos[dataSourceProvider];
    const onToggleExpand = ()=>setIsExpanded(!isExpanded);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.dataSource,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-auto",
                        children: /*#__PURE__*/ _jsx(Avatar, {
                            avatarImg: logo,
                            name: name,
                            className: styles.dataSource__logo,
                            imgClassName: styles.dataSource__logo__img,
                            initialsClassName: styles.dataSource__logo__initials
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: `row align-items-center ${styles.dataSource__headerRow}`,
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "col",
                                    children: [
                                        /*#__PURE__*/ _jsx("h3", {
                                            className: styles.dataSource__name,
                                            children: name
                                        }),
                                        dataSourceInfo && /*#__PURE__*/ _jsx("p", {
                                            className: styles.dataSource__info,
                                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, dataSourceInfo))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "col-auto d-flex flex-nowrap",
                                    children: [
                                        /*#__PURE__*/ _jsx(ConnectionStatus, {
                                            externalDataSource: externalDataSource
                                        }),
                                        /*#__PURE__*/ _jsx(Button, {
                                            className: "collapsible__btn ml-3",
                                            onClick: onToggleExpand,
                                            children: /*#__PURE__*/ _jsx(ChevronRight, {
                                                className: cn('collapsible__btn__icon', {
                                                    'collapsible__btn__icon--collapsed': isExpanded
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(motion.div, {
                animate: {
                    height: isExpanded ? 'auto' : 0
                },
                transition: {
                    ease: 'easeOut',
                    duration: 0.3
                },
                className: styles.dataSource__capabilities,
                children: /*#__PURE__*/ _jsx(Capabilities, {
                    capabilities: capabilities
                })
            })
        ]
    });
};
export default ExternalDataSource;
